/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getStats } from '../fn/stats/get-stats';
import { GetStats$Params } from '../fn/stats/get-stats';
import { StatsResponse } from '../models/stats-response';

@Injectable({ providedIn: 'root' })
export class StatsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStats()` */
  static readonly GetStatsPath = '/stats';

  /**
   * Get Stats.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStats$Response(params?: GetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<StatsResponse>> {
    return getStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Stats.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStats(params?: GetStats$Params, context?: HttpContext): Observable<StatsResponse> {
    return this.getStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatsResponse>): StatsResponse => r.body)
    );
  }

}
